import { lazy } from 'react';
import { BlockWrapper, defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import Template1 from './template1/index.js';
import Template2 from './template2/block.js';

const Inspector = lazy(() => import('./inspector.js'));

function SocialNetworks({ subtitle, title, template, socials, hashtag }) {
    useInspectorControl(Inspector);

    return (
        <BlockWrapper.Div>
            {template === 'template1' ? (
                <Template1 socials={socials} subtitle={subtitle} title={title} />
            ) : (
                <Template2 hashtag={hashtag} />
            )}
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block: SocialNetworks,
    smartProps: {
        subtitle: smartProps.string.withDefault(''),
        title: smartProps.object.withDefault({
            headingLevel: 2,
            content: '',
        }),
        hashtag: smartProps.string.withDefault(''),
        template: smartProps.string.withDefault('template1'),
    },
    setup: {
        title: 'Réseaux sociaux',
    },
});
